import subdivision from '../../polyMesh/geometric/operator/subdivision';

const MeshSmooth = {
  schema: {
    subdivisions: { label: 'Subdivisions', type: 'Number', defaultValue: 1, minValue: 0, maxValue: 4 },
    smoothByMaterialIds: { label: 'Smooth by Material Ids', type: 'Boolean', defaultValue: true },
    //hardEdges: { label: 'Hard Edges', type: 'Boolean', defaultValue: false },
  },

  update: function (operator, primitive) {
    let mesh = primitive.mesh;
    const subdivisions = (operator.subdivisions !== undefined) ? operator.subdivisions : 1;
    //currently we are always assuming hard edges
    //const hardEdges = operator.hardEdges || true;
    if (!mesh) return primitive;

    for (let i = 0; i < subdivisions; i++) {
      mesh = subdivision(mesh, operator.smoothByMaterialIds);
    }

    primitive.mesh = mesh;
    return primitive;
  },
};

export default MeshSmooth;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/MeshSmooth.js